import { Component, Input, OnInit } from '@angular/core';

import { combineLatest, Observable, of } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { Amount } from '@fcom/dapi';
import { FinnairTotalPricesDetails, ServiceFlow } from '@fcom/dapi/api/models';
import { safeMap as safeMapObs } from '@fcom/rx';
import { toAmount } from '@fcom/common-booking/utils/common-booking.utils';
import { hasUnitPrices } from '@fcom/common/utils';

export enum GrandTotalTheme {
  DEFAULT = 'default',
  RENEWED = 'renewed',
}

@Component({
  selector: 'fin-grand-total',
  templateUrl: './grand-total.component.html',
  standalone: false,
})
export class GrandTotalComponent implements OnInit {
  readonly GrandTotalTheme = GrandTotalTheme;
  @Input()
  serviceFlow$: Observable<ServiceFlow | undefined> = of(undefined);

  @Input()
  prices$: Observable<FinnairTotalPricesDetails>;

  /**
   * Theme to be shown
   */
  @Input()
  theme = GrandTotalTheme.DEFAULT;

  @Input()
  useSymbol = false;

  totalPrice$: Observable<Amount>;
  totalPoints$: Observable<number>;
  originalTotalPrice$: Observable<Amount>;

  ngOnInit(): void {
    this.totalPrice$ = combineLatest([this.prices$, this.serviceFlow$]).pipe(
      filter(([prices]) => hasUnitPrices(prices)),
      safeMapObs(([data, serviceFlow]) => {
        const total = data.total.total;
        if (total.totalPoints) {
          if (!serviceFlow || serviceFlow === ServiceFlow.AWARD) {
            const totalAmount = total.totalAmountPaid ?? total.totalAmount;
            return toAmount(totalAmount);
          } else if (
            (serviceFlow === ServiceFlow.BOOKING || serviceFlow === ServiceFlow.MMB_ANCILLARY) &&
            total.totalAmountPaid
          ) {
            return toAmount(total.totalAmountPaid);
          }
        }
        return toAmount(total.totalAmount);
      })
    );

    this.totalPoints$ = this.prices$.pipe(
      filter((data) => !!data?.total?.total?.totalPoints),
      map((data) => +data.total.total.totalPoints.amount)
    );

    this.originalTotalPrice$ = this.prices$.pipe(
      filter((data) => !!data?.flight?.total?.discountReasonCode && !!data?.total?.total?.originalTotalAmount),
      map((data) => data.total.total.originalTotalAmount)
    );
  }
}
